import BanUserDialog from "../../component/dialog/BanUserDialog";
import {
  BLOCK_UNBLOCK_SWITCH,
  GET_USER,
  GET_HISTORY,
  EDIT_COIN,
  OPEN_BAN_USER_DIALOG,
  CLOSE_BAN_USER_DIALOG,
  GET_USER_BAN,
  ADJUST_DAILY_DIAMOND_CAP,
  TOGGLE_USER_VERIFICATION,
  RESET_USER_IDENTITY,
  OPEN_DAILY_DIAMOND_LIMIT_DIALOG,
  CLOSE_DAILY_DIAMOND_LIMIT_DIALOG,
  SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA
} from "./types";

const initialState = {
  user: [],
  male: 0,
  female: 0,
  totalUser: 0,
  activeUser: 0,
  history: [],
  totalHistoryUser: 0,
  income: 0,
  outgoing: 0,
  totalCallCharge: 0,
  liveStreamingIncome: 0,
  banUserDialogData: null,
  banUserDialog: false,
  dailyDiamondLimitDialog: false,
  dailyDiamondLimitDialogData: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload.user,
        male: action.payload.male,
        female: action.payload.female,
        totalUser: action.payload.total,
        activeUser: action.payload.activeUser,
      };

    case BLOCK_UNBLOCK_SWITCH:
      return {
        ...state,
        user: state.user.map((user) => {
          if (user._id === action.payload._id)
            return {
              ...user,
              isBlock: action.payload.isBlock,
              gameBlock: action.payload?.gameBlock,
            };
          else return user;
        }),
      };

    case GET_HISTORY:
      return {
        ...state,
        history: action.payload.history,
        totalHistoryUser: action.payload.total,
        income: action.payload.incomeTotal,
        outgoing: action.payload.outgoingTotal,
        totalCallCharge: action.payload.totalCallCharge,
        liveStreamingIncome: action.payload.income,
      };
    case EDIT_COIN:
      return {
        ...state,
        user: state.user.map((user) => {
          if (user._id === action.payload.id) return action.payload.data;
          else return user;
        }),
      };
    case OPEN_BAN_USER_DIALOG:
      return {
        ...state,
        banUserDialog: true,
      };

    case CLOSE_BAN_USER_DIALOG:
      return {
        ...state,
        banUserDialogData: null,
        banUserDialog: false,
      };

    case GET_USER_BAN:
      return {
        ...state,
        banUserDialogData: action.payload,
      };

    case ADJUST_DAILY_DIAMOND_CAP:
      return {
        ...state,
        user: state.user.map((user) => {
          if (user._id === action.payload._id) {
            return {
              ...user,
              dailyDiamond: action.payload.dailyDiamond,
            };
          }
          return user;
        }),
      };

    case TOGGLE_USER_VERIFICATION:
      return {
        ...state,
        user: state.user.map((user) => {
          if (user._id === action.payload._id) {
            return {
              ...user,
              isVerified: action.payload.isVerified,
            };
          }
          return user;
        }),
      };

    case RESET_USER_IDENTITY:
      return {
        ...state,
        user: state.user.map((user) => {
          if (user._id === action.payload._id) {
            return {
              ...user,
              identity: action.payload.identity,
            };
          }
          return user;
        }),
      };

    case OPEN_DAILY_DIAMOND_LIMIT_DIALOG:
      return {
        ...state,
        dailyDiamondLimitDialog: true,
      };

    case CLOSE_DAILY_DIAMOND_LIMIT_DIALOG:
      return {
        ...state,
        dailyDiamondLimitDialog: false,
        dailyDiamondLimitDialogData: null,
      };

    case SET_DAILY_DIAMOND_LIMIT_DIALOG_DATA:
      return {
        ...state,
        dailyDiamondLimitDialogData: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
